import { Table } from '@mantine/core';
import { Title } from '../../../components/Title';
import { KeyedRow } from '../../../components/KeyedRow';

export function IndividualAttendanceHeaders() {
	return (
		<>
			<Table.Thead>
				<KeyedRow>
					<Table.Th>
						<Title label={'Branch'} />
					</Table.Th>
					<Table.Th>
						<Title label={'Operator Username'} />
					</Table.Th>
					<Table.Th>
						<Title label={'Till Name'} />
					</Table.Th>
					<Table.Th>
						<Title label={'Start Date'} />
					</Table.Th>
					<Table.Th>
						<Title label={'Start Time'} />
					</Table.Th>
					<Table.Th>
						<Title label={'End Date'} />
					</Table.Th>
					<Table.Th>
						<Title label={'End Time'} />
					</Table.Th>
					<Table.Th>
						<Title label={'Total Time'} />
					</Table.Th>
					<Table.Th />
				</KeyedRow>
			</Table.Thead>
		</>
	);
}
